import { MessageSquare, Phone, ShieldAlert } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "../api/client";
import type { Contact } from "../api/types";
import { CommandButton } from "../components/CommandButton";
import { PageShell } from "../components/PageShell";
import { StatusBlock } from "../components/StatusBlock";
import { DEFAULT_EMERGENCY_CONTACT } from "../contactFallback";
import { useHelpStore } from "../stores/helpStore";
import { useNavigationStore } from "../stores/navigationStore";
import styles from "../styles/App.module.css";

export function ContactsPage() {
  const go = useNavigationStore((state) => state.go);
  const requestHelp = useHelpStore((state) => state.requestHelp);
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [contactsLoaded, setContactsLoaded] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .contacts()
      .then((result) => {
        setContacts(result.items);
        setContactsLoaded(true);
      })
      .catch((loadError) => {
        setError(
          loadError instanceof Error ? loadError.message : "读取联系人失败。",
        );
        setContactsLoaded(true);
      });
  }, []);

  const visibleContacts =
    contacts.length > 0
      ? contacts
      : contactsLoaded
        ? [DEFAULT_EMERGENCY_CONTACT]
        : [];

  return (
    <PageShell title="联系家人" where="联系家人页">
      {error ? (
        <StatusBlock
          tone="error"
          message={error}
          recoveryAction={`仍可使用页面上的${DEFAULT_EMERGENCY_CONTACT.name}电话，或点请求帮助进入电话兜底页面。`}
        />
      ) : null}
      {!contactsLoaded ? (
        <StatusBlock message="正在读取联系人。" />
      ) : contacts.length ? null : (
        <StatusBlock message="暂时没有联系人。先显示紧急联系人电话。" />
      )}
      <div className={styles.commandList}>
        <CommandButton
          icon={ShieldAlert}
          title="请求帮助"
          hint="双击后开启本机求助锁，并进入电话兜底页面"
          onClick={() => {
            void requestHelp();
            go({ name: "help" });
          }}
        />
        {visibleContacts.map((contact) => (
          <div className={styles.linkGroup} key={contact.id}>
            <p>
              {contact.name}，{contact.relation}，号码 {contact.phone_display}
            </p>
            <a className={styles.linkButton} href={contact.tel_uri}>
              <Phone aria-hidden="true" /> 打电话给{contact.name}
            </a>
            <a className={styles.linkButton} href={contact.sms_uri}>
              <MessageSquare aria-hidden="true" /> 发短信给{contact.name}
            </a>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
